module.exports = __webpack_public_path__ + "img/11.0102acf4.png";